import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { s } from '@angular/core/src/render3';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    selector: 'app-chatassistant',
    templateUrl: './chat-assistant.component.html',
    styleUrls: ['./chat-assistant.component.scss']
})
export class ChatAssistantComponent implements OnInit {

    @ViewChild('chatInputDiv') inputDiv; 
    @ViewChild('discussion') discussionDiv; 

    @Input() customerName : any;
    @Input() page : any = "";
    @Input() hidden : any = true;

    public expandChatBox: boolean = false;
    public bounceAI: boolean = false;
    public msgList: any = [];
    public chatInput: string = "";
    public TIMEOUT = 60000; //10 mins
    public intervalTimer : any = null;

    constructor(
        private activeRoute: ActivatedRoute,
        private router: Router
    ) {

    }

    ngOnInit() {
        if(this.hidden) return false;

        window["lastActivity"] = Date.now();
        document.addEventListener('click', function(){
            window["lastActivity"] = Date.now();
        })
        this.intervalTimer = setInterval(this.check.bind(this), 3000);
        let list: any = [
            {"message" : "Hello Ravi","sender" : "agent","datetime" : new Date() },
            {"message" : "I am Tavam","sender" : "agent","datetime" : new Date() },
        ];

        if(this.page)
            list.push({"message" : `Do you need any help on ${this.page}?`, "sender" : "agent","datetime" : new Date() });
        else
            list.push({"message" : `How May I Help You?`, "sender" : "agent","datetime" : new Date() });
            
        let user = null;
        let block = [];
        list.map( (o) => {
            if(o.sender != user){
                if(block.length) this.msgList.push(block);
                block = [];
                user = o.sender;
            }
            block.push(o);
        });
        if(block.length) this.msgList.push(block);
    }
    
    createUUID() {
        // http://www.ietf.org/rfc/rfc4122.txt
        var s = [];
        var hexDigits = "0123456789abcdef";
        for (var i = 0; i < 36; i++) {
            s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
        }
        s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010
        s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
        s[8] = s[13] = s[18] = s[23] = "-";

        var uuid = s.join("");
        return uuid;
    }

    messageFunction(objEvent) {
        let { action, args } = objEvent;
        try{
            (this[action] || window[action]).call(this,args);
        }catch(e){

        }
    }

    sendNewMessage() {
        var userInput = this.inputDiv.nativeElement.innerHTML;
        var newMessage = userInput.replace(/\<div\>|\<br.*?\>|\<br\>/ig, '\n').replace(/\<\/div\>/g, '\n').trim().replace(/\n/g, '<br>');

        if (!newMessage) return;

        let size = this.msgList.length;
        if(this.msgList.length){
            if(this.msgList[size-1][0].sender == "action"){
                this.msgList.push([{ "message": newMessage }]);
            } else if(this.msgList[size-1][0].sender != "agent"){
                this.msgList[size-1].push({ "message": newMessage });
            } else {
                this.msgList.push([{ "message": newMessage }]);
            }
        } else {
            this.msgList.push([{ "message": newMessage }]);
        }
        
        // clean out old message
        this.inputDiv.nativeElement.innerHTML = "";
        let element = this.discussionDiv.nativeElement;
        setTimeout(function(){
            element.scrollTop = element.scrollHeight;
        },500);
        
    }

    onMetaAndEnter(event) {
        if ((event.metaKey || event.ctrlKey) && event.keyCode == 13) {
            this.sendNewMessage();
        }
    }

    operChat(){
        this.expandChatBox = true;
        clearInterval(this.intervalTimer);   
    }

    closeChat(){
        this.expandChatBox = false;
        this.intervalTimer = setInterval(this.check.bind(this), 3000);   
    }

    check() {
        var currentTime = Date.now();
        if (currentTime - window["lastActivity"] > this.TIMEOUT) {
            this.bounceAI = true;
        }
    }
}